import React from 'react';

const CustomCursor = () => {
  return null;
};

export default CustomCursor;
